import React from 'react'
import styled from 'styled-components'
import { Box, Link } from '@ally/metronome-ui'
import { toJSON } from '@ally/fido'
import { useHostServices } from '../HostServices'
import { apiKey } from './index'

export const List = styled.ul`
  ${({ theme: { colors, space } }): string => `
  padding: 0;
  margin: 0;
  line-height: 1.5;

    & ~ & {
      margin-top: ${space.sm};
      padding-top: ${space.sm};
      border-top: 1px solid ${colors['slate-2']};
    }
  `};
`

export const ListItem = styled.li`
  ${({ theme: { colors, space } }): string => `
    list-style: none;
    display: flex;
    padding: ${space.sm} 0;
    border-bottom: 1px solid ${colors['slate-2']};

    &:first-of-type {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
  `};
`

const TipsMbox: React.FC<{ tips: any[] }> = ({ tips }) => {
  const { session } = useHostServices()
  const guid = session.data?.guid

  const clickTrack = async (tip: any): Promise<void> => {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'api-key': apiKey,
    }

    const {
      Benefits,
      Issue,
      Group,
      Name,
      Treatment,
      InteractionID,
      Direction,
      Channel,
      Rank,
    } = tip
    const requestBody = {
      CustomerID: guid,
      ContainerName: 'iBubble',
      RankedResults: [
        {
          Benefits,
          Issue,
          Group,
          Name,
          Treatment,
          InteractionID,
          Direction,
          Channel,
          Outcome: 'Clicked',
          Rank,
        },
      ],
    }

    const response = await fetch('/acs/cihcontainer-forweb/CaptureResponse', {
      method: 'POST',
      headers,
      body: JSON.stringify(requestBody),
    })

    await toJSON<any>(response)
  }
  return (
    <>
      <List>
        {tips.map((tip: any, index) => {
          return (
            <ListItem
              key={`ibubble-${tip.InteractionID}`}
              data-testid="tips-item"
            >
              <Box flex="1">
                <Box display="inline" mr="xs">
                  {tip.Benefits}
                  {tip.ClickThroughURL && (
                    <Link
                      to={tip.ClickThroughURL}
                      text="Learn more"
                      onClick={(e): void => {
                        clickTrack(tip)
                      }}
                      marginLeft="xs"
                    />
                  )}
                </Box>
              </Box>
            </ListItem>
          )
        })}
      </List>
    </>
  )
}

export default TipsMbox
